import { Modal } from 'ant-design-vue';
import {marked} from 'marked';
import hljs from 'highlight.js';
import html2canvas from 'html2canvas'
import 'highlight.js/styles/foundation.css';
import cheerio from 'cheerio';
import {cmp} from "@/utils/request";
import domtoimagemore from 'dom-to-image-more';


export const markdownToHtml = (text)=> {
    const render = new marked.Renderer();
    marked.setOptions({
        renderer: render, // 这是必填项
        gfm: true,	// 启动类似于Github样式的Markdown语法
        breaks: true,
        // pedantic: false, // 只解析符合Markdwon定义的，不修正Markdown的错误
        // sanitize: false, // 原始输出，忽略HTML标签（关闭后，可直接渲染HTML标签）,
        smartLists: true,
        smartypants: false,
        xhtml : false,
        // 高亮的语法规范
        highlight: (code, lang) => hljs.highlight(code, { language: lang }).value,
    });
    return typeof text === 'string'? marked(text): text;
}
export const markdownToJson1 = (text)=>{
    if(typeof text === 'string') {
        return cheerio.load(marked(text));
    }
    return text;
};
export const markdownToJson = (el)=>{
    if(typeof text === 'string') {
        var obj = {
            tag: el.tagName.toLowerCase()
        };

        if (el.attributes.length > 0) {
            obj.attributes = {};
            Array.prototype.slice.call(el.attributes).forEach(function (attr) {
                obj.attributes[attr.name] = attr.value;
            });
        }

        var children = [];

        Array.prototype.slice.call(el.childNodes).forEach(function (node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
                children.push(markdownToJson(node));
            } else if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()) {
                children.push(node.nodeValue.trim());
            }
        });

        if (children.length > 0) {
            obj.children = children;
        }

        return obj;
    }
    return el;
}
export const setState = (obj, values, func) => {
    console.log('setState')
    if(values === null){
        console.log('空')
    }
    else if(typeof values === 'object'){
        Object.keys(values).map(k=>{
            obj[k] = values[k];
        })
    }
    if(func) func();
};
// 发消息
export const jy_tip = (content, level='info') => {
    Modal[level]({content});
};
export const formatColumns = (columns)=>{
    return columns.map((col, index)=>{
        if(typeof col === 'string') col = {title: col, dataIndex: index, key: index, filterable: true};
        else col = col || {};
        let {dataIndex} = col;
        col = {
            ...col,
            sorter: (a, b) => cmp(a[dataIndex], b[dataIndex]),
            sortDirections: ['descend', 'ascend'],
        };
        let {filterable} = col;
        if(filterable) col = {
            ...col,
            customFilterDropdown: true,
            onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toString().toLowerCase()),
        };
        return col;
    })
};

export const exportAsImage = async (element, func) => {
    try {
        // 显示加载提示
        // let m = Modal.info({
        //     content: '正在生成图片，请稍候...',
        //     type: 'info',
        //     duration: 0,
        //     showClose: true
        // });

        // 获取要导出的DOM元素

        // 创建canvas，添加更多配置选项
        // html2canvas(element).then(canvas => {
        //     // 将canvas转换为图片并下载
        //     const imgData = canvas.toDataURL('image/png');
        //     func(imgData);
        // });
        const canvas = await html2canvas(element, {
            scale: 2, // 提高图片质量
            useCORS: true, // 允许加载跨域图片
            allowTaint: true, // 允许加载跨域图片（即使可能污染画布）
            backgroundColor: '#ffffff', // 设置背景色
            logging: true, // 开启日志以便调试
            foreignObjectRendering: false, // 禁用foreignObject渲染，提高兼容性
            removeContainer: true, // 移除临时创建的容器
            onclone: (clonedDoc) => {
                // 确保克隆的文档中包含所有必要的样式
                const styles = document.querySelectorAll('style[data-md-style]');
                styles.forEach(style => {
                    clonedDoc.head.appendChild(style.cloneNode(true))
                })
            }
        });
        // m.destroy();
        func(canvas.toDataURL());
        // // 转换为图片并下载
        // const link = document.createElement('a')
        // link.download = 'markdown-card.png';
        // link.href = canvas.toDataURL('image/png', 1.0)
        // link.click();

        // jy_tip('图片导出成功', 'success')
    } catch (error) {
        jy_tip(`图片导出失败: ${error}`, 'error')
    }
};
// 电脑端
export const copyImageToClipboard = (imageUrl) => {
    // 创建一个临时的canvas元素
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.crossOrigin = 'Anonymous'; // 如果是跨域图片，需要设置这个属性
    img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        canvas.toBlob(async (blob) => {
            if (blob) {
                // 检查剪贴板权限
                const permission = await checkClipboardPermission();
                if (permission === 'denied') {
                    throw new Error('用户已拒绝剪贴板权限，请在浏览器设置中启用');
                }
                try {
                    await navigator.clipboard.write([
                        new ClipboardItem({ [blob.type]: blob })
                    ]);
                    console.log('图片已复制到粘贴板');
                    jy_tip('图片已复制到粘贴板！');
                } catch (err) {
                    console.log('复制图片失败：' + err);
                    // 回退机制：提示用户长按图片保存
                    if (err.name === 'NotAllowedError' || err.name === 'DOMException') {
                        copyImageUrl(imageUrl);
                        jy_tip('由于浏览器限制，无法直接复制图片。请手动截图保存。');
                    } else {
                        // 其他错误处理
                        jy_tip('复制图片失败：' + blob.type + '. Permission: '  + permission + '. ' + err);
                    }

                }
            }
        });
    };
    img.src = imageUrl; // 设置图片源为你的图片URL
};
// 手机端
export const copyImageToClipboardByPhone = (imgData, previewImgId, mobileTipId, scrollContainerId)=>{
    const previewImg = document.getElementById(previewImgId);
    const mobileTip = document.getElementById(mobileTipId);
    const el = document.getElementById(scrollContainerId);
    // --- 移动端：生成图片并提示长按保存 ---
    previewImg.style.display = 'block';
    previewImg.src = imgData;
    if(mobileTip)mobileTip.style.display = 'block';
    // 阻止移动端长按图片的默认行为（避免弹出浏览器默认菜单）
    if(el){
        el.scrollTo({ top: el.scrollHeight - el.clientHeight, behavior: 'smooth' })
    }
    previewImg.addEventListener('contextmenu', (e) => e.preventDefault());
};
export const downImg = (imgData)=>{

    const link = document.createElement('a');
    link.href = imgData;
    link.setAttribute('download', 'VIPaper.png');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
// 创建临时输入框复制图片URL
export const copyImageUrl = (url) => {
    const input = document.createElement('input');
    input.value = url;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
};
// 另一种方式：截图并预览
export const captureAsImage = async (domEle, func) => {
    if (!domEle) return;

    try {
        const dataUrl = await domtoimagemore.toPng(domEle, {
            bgcolor: '#ffffff',
            quality: 1,
            cacheBust: true // 防止缓存问题
        });
        func(dataUrl);
        // previewImage.value = dataUrl;
        // previewVisible.value = true
    } catch (error) {
        jy_tip('生成预览失败')
    }
};
// 检查剪贴板权限
export const checkClipboardPermission = async () => {
    try {
        const permissionStatus = await navigator.permissions.query({
            name: 'clipboard-write'
        });
        return permissionStatus.state;
    } catch (error) {
        return 'prompt'; // 默认提示
    }
};

export const checkStatus = (status, num)=>{
    return (status & num) === num;
};